module.exports = __webpack_public_path__ + "img/img2.6455307c.svg";